import http from './http'

// 获取列表
export function pageList (data) {
  return http.get('/user/order/pagelist?'+data)
}

// 删除同步项
export function remove (key) {
  return http.delete(`/user/order?orderKey=${key}`)
}

export function repay (data) {
  return http.post(`/user/order/repay?orderKey=${data.orderKey}&payType=${data.payType}`)
}

export function pageVipList (data) {
  return http.get('client/vip/buy/order?'+data)
}

export function pageFbList (data) {
  return http.get('client/fb/buy/order?'+data)
}

export function queryOrder (data) {
  return http.get(`/user/order/query?orderKey=${data}`)
}

export function pageFbFreeList (data) {
  return http.get('client/fb/free/record?'+data)
}
